
import { CustomFusionMap, CustomMapOptions } from "./CustomFusionMap";
const nmMap: CustomMapOptions = {
    name: "NorthernMarianaIslands",
    displayName: "Northern Mariana Islands",
    entities: {
        "001": {
            outlines: ['M 388.43 388.37 391.34 389.46 390.61 392.13 387.86 393.86 384.94 395.35 382.19 395.04 381.62 394.1 379.92 395.27 379.2 394.02 381.71 390.64 384.94 389.54 388.43 388.37 Z'],
            label: "Rota",
            shortLabel: "RO",
            labelPosition: [441, 392],
            labelConnectors: ["M, 431, 392, L, 391.30, 392.20"],
        },
        "002": {
            outlines: ['M 421.63 324 423.41 326.27 422.44 328.06 420.41 330.02 420.9 332.91 419.76 334.39 418.15 334.31 418.63 336.11 417.01 337.99 413.77 336.43 413.04 333.92 413.93 329.16 414.83 326.66 417.01 327.2 421.63 324 Z'],
            label: "Saipan",
            shortLabel: "SA",
            labelPosition: [473, 331],
            labelConnectors: ["M, 463, 331, L, 423.40, 330.80"],
        },
        "003": {
            outlines: ["M 411.18 335.68 412.44 336.89 412.68 338.54 412.11 339.87 413.57 341.47 413.49 342.76 412.6 345.89 410.65 347.1 409.6 346.32 409.28 344.79 408.39 343.11 407.13 342.6 407.17 341 407.78 338.93 409.52 336.93 411.18 335.68 Z"],
            label: "Tinian",
            shortLabel: "TI",
            labelPosition: [464, 341],
            labelConnectors: ["M, 454, 341, L, 413.60, 341.10"],
        },
        "004": {
            outlines: ["M 407.29 349.64 407.66 350.47 407.09 351.33 404.78 351.8 404.58 351.45 404.34 350.78 405.55 350.11 407.29 349.64 Z"],
            label: "Aguijan",
            shortLabel: "AG",
            labelPosition: [458, 351],
            labelConnectors: ["M, 448, 351, L, 407.70, 350.70"],
        },
        "005": {
            outlines: ["M 435.88 281.32 436.1 281.61 435.88 282.13 435.28 282.94 435.04 282.93 435.24 282.27 435.61 281.58 435.88 281.32 Z"],
            label: "Farallon de Medinilla",
            shortLabel: "FM",
            labelPosition: [486, 282],
            labelConnectors: ["M, 476, 282, L, 436.10, 282.00"],
        },
        "006": {
            outlines: ["M 412.92 260.79 415.47 261.13 416.57 262.11 416 263.27 414.95 263.7 410.82 263.78 409.97 262.18 410.25 260.94 412.92 260.79 Z"],
            label: "Anatahan",
            shortLabel: "AN",
            labelPosition: [467, 262],
            labelConnectors: ["M, 457, 262, L, 416.60, 262.10"],
        },
        "007": {
            outlines: ["M 422.62 204.87 423.41 205.18 423.65 205.74 423.61 206.22 422.98 206.98 422.15 206.51 421.93 205.95 422.13 205.12 422.62 204.87 Z"],
            label: "Guguan",
            shortLabel: "GU",
            labelPosition: [474, 206],
            labelConnectors: ["M, 464, 206, L, 423.60, 205.70"],
        },
        "008": {
            outlines: ["M 422.58 187.24 423.41 187.96 423.77 188.96 423.49 189.56 422.58 190.16 421.44 190.14 421.02 189.15 421.12 188.19 421.44 187.51 422.58 187.24 Z"],
            label: "Alamagan",
            shortLabel: "AL",
            labelPosition: [474, 189],
            labelConnectors: ["M, 464, 189, L, 423.80, 188.60"],
        },
        "009": {
            outlines: ["M 419.08 154.7 420.98 155.24 421.51 156.55 421.3 158.28 420.25 159.71 418.83 159.59 417.94 161.09 416.81 162.36 415.19 162.98 414.5 162.86 414.91 160.94 415.8 159.71 416.93 159.24 417.38 158.36 417.09 156.59 417.94 155.05 419.08 154.7 Z"],
            label: "Pagan",
            shortLabel: "PA",
            labelPosition: [472, 159],
            labelConnectors: ["M, 462, 159, L, 421.50, 158.70"],
        },
        "010": {
            outlines: ["M 411.99 116.62 413.89 117.42 414.58 118.49 415.03 120.14 414.62 121.45 413.61 122.37 412.27 122.79 410.86 121.68 410.37 119.87 410.45 118.03 411.99 116.62 Z"],
            label: "Agrihan",
            shortLabel: "AG",
            labelPosition: [465, 120],
            labelConnectors: ["M, 455, 120, L, 415.00, 119.60"],
        },
        "011": {
            outlines: ["M 396.65 64.1 397.98 64.22 398.22 65.48 397.66 66.47 396.44 66.66 395.47 66.08 395.71 64.75 396.65 64.1 Z"],
            label: "Asuncion Island",
            shortLabel: "AS",
            labelPosition: [448, 65],
            labelConnectors: ["M, 438, 65, L, 398.20, 65.20"],
        },
        "012": {
            outlines: ["M 386.36 44.84 387.17 45.18 387.86 46.24 386.65 46.89 385.67 46.81 385.03 46.17 385.39 45.18 386.36 44.84 Z"],
            label: "Maug Islands",
            shortLabel: "MA",
            labelPosition: [438, 46],
            labelConnectors: ["M, 428, 46, L, 387.90, 45.80"],
        },
        "013": {
            outlines: ["M 366.89 14.36 367.19 14.59 367.66 14.67 367.68 15.18 367.17 15.77 366.52 15.67 366.22 15.33 366.48 14.55 366.89 14.36 Z"],
            label: "Farallon de Pajaros",
            shortLabel: "FP",
            labelPosition: [418, 15],
            labelConnectors: ["M, 408, 15, L, 367.70, 14.90"],
        },
    },
};

export default CustomFusionMap(nmMap);
